/** Superadministrador: todas las sucursales del establecimiento. */
export function isSuperAdmin(rol?: string | null): boolean {
  return rol === "superadmin";
}

/** Admin de sucursal: solo la sucursal asignada (branch_id). */
export function isBranchAdmin(rol?: string | null): boolean {
  return rol === "admin";
}

export function canSwitchBranch(rol?: string | null): boolean {
  return isSuperAdmin(rol);
}

/** Crear/editar/eliminar sucursales del establecimiento. */
export function canManageBranches(rol?: string | null): boolean {
  return isSuperAdmin(rol);
}

/** Comprueba si el rol del usuario está en la lista permitida por la ruta. */
export function isRoleAllowed(currentRole: string, allowedRoles: string[]): boolean {
  const role = currentRole.toLowerCase().trim();
  const allowed = allowedRoles.map((r) => r.toLowerCase().trim());
  if (allowed.includes(role)) return true;
  if (isSuperAdmin(role) && allowed.includes("admin")) return true;
  return false;
}
